module.exports = __webpack_public_path__ + "media/images/icon__questionmark--rb-light-gray@3x-b9ca6386685556c44915347bd919e5c6.png";